import { useGetIdentity } from "@refinedev/core";
import { Navigate, Outlet } from "react-router";
import type { UserInfo } from "../types/auth";
import { LoadingSpinner } from "./common/LoadingSpinner";

/**
 * Route guard for coordinator-only pages.
 * Only user_type=4 (Auditor Manager / coordinator) can pass; anyone else
 * is bounced to /auditor/home so a regular auditor doesn't see an empty
 * assignment screen.
 */
export const CoordinatorRoute = () => {
  const { data: identity, isLoading } = useGetIdentity<UserInfo>();

  if (isLoading) {
    return <LoadingSpinner fullScreen tip="Checking permissions..." />;
  }

  if (identity?.app_user?.user_type !== 4) {
    return <Navigate to="/auditor/home" replace />;
  }

  return <Outlet />;
};
